import { Injectable, inject } from '@angular/core';
import {
  GetRowsRequest,
  RestApiService,
} from '@core/services/rest-api.service';
import {
  DvDropdownClientSideElement,
  DvRadioGroupLegacyElement,
  DvSlideToggleElement,
} from '@devinco/ui/legacy';
import { Entity } from '@shared/constants/entity';
import { TranslateService } from '@ngx-translate/core';
import { FilterCondition } from '@pages/on-call-page/constants';
import { OnCallDto } from '../../../interfaces';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import { activeRecordFilter } from '@shared/constants/active-record-filter';
@Injectable({ providedIn: 'root' })
export class OnCallGridPanelElementsService {
  private api = inject(RestApiService);
  private translate = inject(TranslateService);

  locationStatusElements = (): DvDynamicFormElement[] => [
    new DvSlideToggleElement({
      key: 'ShowOnlyStandby',
      slideToggleLabel: 'OnCallGridPanel.ShowOnlyStandby',
      colspan: 12,
    }),
  ];

  getDepartmentUserLocationElements = (): DvDynamicFormElement[] => [
    new DvDropdownClientSideElement({
      isClearable: true,
      colspan: 12,
      key: 'Department',
      label: '',
      isMultipleSelectionEnabled: true,
      closeOnSelect: false,
      labelKeys: ['DepartmentDescription'],
      placeholder: 'OnCallGridPanel.DepartmentAll',
      valueKey: 'DepartmentID',
      open: params => {
        const request: GetRowsRequest = {
          entity: Entity.Department,
          fields: ['DepartmentID', 'DepartmentDescription'],
          filterModel: activeRecordFilter,
        };
        this.api.setDropdownData(request, params);
      },
    }),
    new DvDropdownClientSideElement({
      isClearable: true,
      colspan: 12,
      key: 'User',
      label: '',
      labelKeys: ['UserNameDescription'],
      isMultipleSelectionEnabled: true,
      closeOnSelect: false,
      placeholder: 'OnCallGridPanel.UserAll',
      valueKey: 'UserID',
      open: params => {
        const request: GetRowsRequest = {
          entity: Entity.User,
          fields: ['UserID', 'UserNameDescription'],
        };
        this.api.setDropdownData(request, params);
      },
    }),
    new DvDropdownClientSideElement({
      isClearable: true,
      colspan: 12,
      key: 'Location',
      label: '',
      labelKeys: ['Description'],
      isMultipleSelectionEnabled: true,
      closeOnSelect: false,
      placeholder: 'OnCallGridPanel.LocationALL',
      valueKey: 'Description',
      open: params => {
        const request: GetRowsRequest = {
          entity: Entity.OnCall,
          fields: ['Description'],
          filterModel: {
            IsLocation: {
              filterType: 'number',
              type: 'equals',
              filter: 1,
            },
          },
        };
        const locationDataMapFn = (data: OnCallDto[]): OnCallDto[] => {
          return data.filter(
            (value, index, self) =>
              index === self.findIndex(t => t.Description === value.Description)
          );
        };
        this.api.setDropdownData(request, params, locationDataMapFn);
      },
    }),
  ];

  getUserPropertyEelements = (): DvDynamicFormElement[] => [
    this.getConditionRadioGroup('UserCondition'),
    new DvDropdownClientSideElement({
      isClearable: true,
      colspan: 12,
      key: 'UserTag',
      label: '',
      labelKeys: ['TagDescription'],
      isMultipleSelectionEnabled: true,
      closeOnSelect: false,
      placeholder: 'OnCallGridPanel.PropertyUserAll',
      valueKey: 'TagDescription',
      open: params => {
        const request: GetRowsRequest = {
          entity: Entity.TagUser,
          fields: ['TagDescription'],
        };
        this.api.setDropdownData(request, params);
      },
    }),
  ];

  getVehiclePropertyElements = (): DvDynamicFormElement[] => [
    this.getConditionRadioGroup('VehicleCondition'),
    new DvDropdownClientSideElement({
      isClearable: true,
      colspan: 12,
      key: 'VehicleTag',
      label: '',
      labelKeys: ['TagDescription'],
      isMultipleSelectionEnabled: true,
      closeOnSelect: false,
      placeholder: 'OnCallGridPanel.PropertyVehicleAll',
      valueKey: 'TagDescription',
      open: params => {
        const request: GetRowsRequest = {
          entity: Entity.TagVehicle,
          fields: ['TagDescription'],
        };
        this.api.setDropdownData(request, params);
      },
    }),
  ];

  private getConditionRadioGroup = (
    key: 'VehicleCondition' | 'UserCondition'
  ): DvDynamicFormElement =>
    new DvRadioGroupLegacyElement({
      colspan: 12,
      key,
      direction: 'vertical',
      labelKey: 'label',
      valueKey: 'value',
      label: '',
      value: FilterCondition.Or,
      items: [
        {
          label: this.translate.instant('OnCallGridPanel.AndCondition'),
          value: FilterCondition.And,
        },
        {
          label: this.translate.instant('OnCallGridPanel.OrCondition'),
          value: FilterCondition.Or,
        },
      ],
      gridSize: 500,
      hintLeft: ' ',
    });
}
